<template>
    <router-view/> |
</template>

<style>
  @import "~bootstrap/dist/css/bootstrap.min.css";
</style>
